import { useDayjs, useState } from '#imports'

export const useClock = () => {
    const dayjs = useDayjs()
    const clock = useState<string>('serverTime', () => dayjs.tz().toISOString())

    function setClock(datetime: string) {
        clock.value = datetime
    }

    return {
        clock,
        setClock,
    }
}
